import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { SortByKeyPipe } from "../../../core/pipes/sort-by-key.pipe";
import { ScriptEditorControlsService } from "../../../core/services/script-editor-controls.service";
import { MaterialModule } from "../../../core/shared/material.module";
import { SharedComponents } from "../../shared.module";

@Component({
  selector: "app-custom-header",
  standalone: true,
  imports: [MaterialModule, CommonModule, ...SharedComponents, SortByKeyPipe],
  templateUrl: "./custom-header.component.html",
  styleUrl: "./custom-header.component.scss",
})
export class CustomHeaderComponent {
  @Input() data: any = {
    title: "Data Connection",
    titleImgUrl: "../../../../assets/images/connection.png",
    buttonLabel: "Load Recorded Scripts",
  };

  constructor(private readonly scriptEditorControlsService: ScriptEditorControlsService) {
  }

  onUserClick(control: any) {
    this.scriptEditorControlsService.onControlClick({
      type: control
    });
  }
}
